import { InjectionToken } from '@angular/core';
import { ConditionEvaluatorFunction } from './conditions.model';

export interface ConditionEvaluator {
  type: string;
  evaluator: ConditionEvaluatorFunction;
}

export const CONDITIONS_EVALUATORS: InjectionToken<ConditionEvaluator[]> = new InjectionToken<ConditionEvaluator[]>(
  'CONDITIONS_EVALUATORS'
);
